import lodash from 'lodash';

export default function tallyAndValidateChoiceSets(
  choiceSets: ChoiceSetWithQuantity[],
  choiceSetDiscountConfig?: ChoiceSetQuantityDiscountConfig,
): ValidatedChoiceSet[] {
  let discount: string;
  if (choiceSetDiscountConfig) {
    discount = choiceSetDiscountConfig.discountPlu;
  }

  return choiceSets?.map(choiceSet => {
    function removeDiscountPLU(choice: any) {
      return choice.plucode != discount;
    }

    const arrayWithoutDiscountPLU = choiceSet.choices.filter(removeDiscountPLU);

    const quantity = lodash.sumBy(arrayWithoutDiscountPLU, 'quantity');

    let valid = true;
    if (choiceSet.required && quantity === 0) {
      valid = false;
    }

    if (choiceSet.max && quantity > choiceSet.max) {
      valid = false;
    }

    if (choiceSet.min && quantity && quantity < choiceSet.min) {
      valid = false;
    }

    return {
      ...choiceSet,
      quantity,
      valid,
    };
  });
}
